import type { SegmentFilters, SegmentFiltersQueryParams } from '../types';
import { extractRange } from './extractRange';

export type ConstructSegmentFilterParams = {
  filters?: Partial<SegmentFilters>;
  searchPhrase?: string;
};

export const constructSegmentFilterParams = ({
  filters,
  searchPhrase,
}: ConstructSegmentFilterParams): SegmentFiltersQueryParams => {
  const { min: reachMin, max: reachMax } = extractRange(filters?.reach);
  const { min: pricePomMin, max: pricePomMax } = extractRange(filters?.pricePom);
  const { min: priceCpmMin, max: priceCpmMax } = extractRange(filters?.priceCpm);

  const params: SegmentFiltersQueryParams = {
    limit: 100,
    offset: 0,
    phrase: searchPhrase,
    reach: { min: reachMin, max: reachMax },
    pricePom: { min: pricePomMin, max: pricePomMax },
    priceCpm: { min: priceCpmMin, max: priceCpmMax },
    dataPartner: filters?.dataPartner,
    dataProvider: filters?.dataProvider,
    category: filters?.category,
    subCategory: filters?.subCategory,
    lifestyles: filters?.lifestyles,
    shopping: filters?.shopping,
    past_browsing_interests: filters?.past_browsing_interests,
    purchase_propensity: filters?.purchase_propensity,
    advanced_demographics: filters?.advanced_demographics,
    attitudes: filters?.attitudes,
    location_visits: filters?.location_visits,
    lookalike: filters?.lookalike,
    marketplace: filters?.marketplace,
  };

  return params;
};
